// import React, { useState, useEffect, useCallback } from 'react';
// import { useSelector, useDispatch } from 'react-redux';
// import { 
//   Bell, 
//   Check, 
//   Trash2, 
//   CheckCheck, 
//   X, 
//   Info, 
//   AlertCircle, 
//   AlertTriangle,
//   CheckCircle,
//   Clock,
//   MailOpen,
//   Mail
// } from 'lucide-react';
// import { 
//   Get_Notification, 
//   Delete_Notification, 
//   Read_Notification, 
//   ReadAll_Notification ,
//   UnReadcount_Notification
// } from '../../../services/oprations/Bussiness_Logic';
// import toast from 'react-hot-toast';

// const NotificationCenter = ({ isOpen, onClose }) => {
//   const dispatch = useDispatch();
//   const { token } = useSelector((state) => state.auth);
//   const { notification } = useSelector((state) => state.Notification);
//   let notifications = notification;
  
//   const [loading, setLoading] = useState(true);
//   const [unreadcount,setUnReadCount] = useState(0)
//   const [filter, setFilter] = useState('all');
//   const [showDeleteConfirm, setShowDeleteConfirm] = useState(null);

//   // Fetch notifications when component mounts or when panel opens
//   useEffect(() => {
//     if (isOpen) {
//       fetchNotifications();
//     }
//   }, [isOpen]);

//   const fetchNotifications = async () => {
//     setLoading(true);
//     await dispatch(Get_Notification(token));
//     // const res = await dispatch(UnReadcount_Notification(token))
//     // if(res?.data?.success){
//     //     setUnReadCount(res?.data?.data)
//     // }
//     setLoading(false);
//   };

//   // Get notification icon based on type
//   const getNotificationIcon = (type) => {
//     const iconClasses = "w-5 h-5";
//     switch (type) {
//       case 'SUCCESS':
//         return <CheckCircle className={`${iconClasses} text-green-400`} />;
//       case 'WARNING':
//         return <AlertTriangle className={`${iconClasses} text-yellow-400`} />;
//       case 'ERROR':
//         return <AlertCircle className={`${iconClasses} text-red-400`} />;
//       default:
//         return <Info className={`${iconClasses} text-blue-400`} />;
//     }
//   };

//   // Get notification background color based on type
//   const getNotificationBgColor = (type, isRead) => {
//     if (isRead) return 'bg-gray-800/30';
    
//     switch (type) {
//       case 'SUCCESS':
//         return 'bg-green-900/20 border-l-4 border-green-500';
//       case 'WARNING':
//         return 'bg-yellow-900/20 border-l-4 border-yellow-500';
//       case 'ERROR':
//         return 'bg-red-900/20 border-l-4 border-red-500';
//       default:
//         return 'bg-blue-900/20 border-l-4 border-blue-500';
//     }
//   };

//   // Format time
//   const formatTime = (date) => {
//     const now = new Date();
//     const notificationDate = new Date(date);
//     const diffMs = now - notificationDate;
//     const diffMins = Math.floor(diffMs / 60000);
//     const diffHours = Math.floor(diffMs / 3600000);
//     const diffDays = Math.floor(diffMs / 86400000);

//     if (diffMins < 1) return 'Just now';
//     if (diffMins < 60) return `${diffMins} min ago`;
//     if (diffHours < 24) return `${diffHours} hour${diffHours > 1 ? 's' : ''} ago`;
//     if (diffDays < 7) return `${diffDays} day${diffDays > 1 ? 's' : ''} ago`;
//     return notificationDate.toLocaleDateString();
//   };

//   // Handle mark as read
//   const handleMarkAsRead = async (id) => {
//     await dispatch(Read_Notification(id, token));
//     toast.success('Marked as read');
//   };

//   // Handle delete
//   const handleDelete = async (id) => {
//     await dispatch(Delete_Notification(id, token));
//     setShowDeleteConfirm(null);
//     toast.success('Notification deleted');
//   };

//   // Handle mark all as read
//   const handleMarkAllAsRead = async () => {
//     await dispatch(ReadAll_Notification(token));
//     toast.success('All notifications marked as read');
//   };

//   // Filter notifications
//   const filteredNotifications = notifications?.filter(notif => {
//     if (filter === 'unread') return !notif.isRead;
//     if (filter === 'read') return notif.isRead;
//     return true;
//   });

//   const unreadCount = notifications?.filter(n => !n.isRead).length || 0;

//   return (
//     <>
//       {/* Notification Sidebar Panel */}
//       {isOpen && (
//         <div className="fixed inset-0 z-50 overflow-hidden">
//           {/* Backdrop */}
//           <div 
//             className="absolute inset-0 transition-opacity duration-300 bg-black/50 backdrop-blur-sm"
//             onClick={onClose}
//           />
          
//           {/* Notification Panel - Slides in from right */}
//           <div className="absolute top-0 right-0 w-full h-full max-w-md border-l shadow-2xl bg-gradient-to-br from-gray-900 via-blue-900 to-gray-900 border-blue-800/50 animate-slide-in">
//             {/* Header */}
//             <div className="flex items-center justify-between p-4 border-b border-blue-800/50 bg-blue-900/30">
//               <div className="flex items-center gap-2">
//                 <Bell className="w-6 h-6 text-blue-400" />
//                 <h2 className="text-xl font-bold text-white">Notifications</h2>
//                 {unreadCount > 0 && (
//                   <span className="px-2 py-1 text-xs text-red-400 rounded-full bg-red-500/20">
//                     {unreadCount} unread
//                   </span>
//                 )}
//               </div>
//               <button
//                 onClick={onClose}
//                 className="p-1 transition-colors rounded-lg hover:bg-blue-800/50"
//               >
//                 <X className="w-5 h-5 text-gray-400" />
//               </button>
//             </div>

//             {/* Filter Tabs */}
//             <div className="flex gap-2 p-4 border-b border-blue-800/50 bg-blue-900/20">
//               <button
//                 onClick={() => setFilter('all')}
//                 className={`flex-1 px-3 py-2 rounded-lg text-sm font-medium transition-all duration-300 ${
//                   filter === 'all'
//                     ? 'bg-blue-600 text-white shadow-lg'
//                     : 'bg-gray-800/50 text-gray-300 hover:bg-gray-700/50'
//                 }`}
//               >
//                 All
//               </button>
//               <button
//                 onClick={() => setFilter('unread')}
//                 className={`flex-1 px-3 py-2 rounded-lg text-sm font-medium transition-all duration-300 ${
//                   filter === 'unread'
//                     ? 'bg-blue-600 text-white shadow-lg'
//                     : 'bg-gray-800/50 text-gray-300 hover:bg-gray-700/50'
//                 }`}
//               >
//                 Unread
//               </button>
//               <button
//                 onClick={() => setFilter('read')}
//                 className={`flex-1 px-3 py-2 rounded-lg text-sm font-medium transition-all duration-300 ${
//                   filter === 'read'
//                     ? 'bg-blue-600 text-white shadow-lg'
//                     : 'bg-gray-800/50 text-gray-300 hover:bg-gray-700/50'
//                 }`}
//               >
//                 Read
//               </button>
//             </div>

//             {/* Actions Bar */}
//             {notifications?.length > 0 && (
//               <div className="flex items-center justify-between p-4 border-b border-blue-800/50">
//                 <button
//                   onClick={handleMarkAllAsRead}
//                   disabled={unreadCount === 0}
//                   className="flex items-center gap-2 px-3 py-1.5 text-sm text-blue-100 hover:text-blue-50 disabled:opacity-50 disabled:cursor-not-allowed transition-colors"
//                 >
//                   <CheckCheck className="w-4 h-4" />
//                   Mark all as read
//                 </button>
//                 <span className="text-xs text-gray-400">
//                   {notifications?.length} total
//                 </span>
//               </div>
//             )}

//             {/* Notifications List */}
//             <div className="flex-1 overflow-y-auto h-[calc(100vh-180px)]">
//               {loading ? (
//                 <div className="flex items-center justify-center py-12">
//                   <div className="w-8 h-8 border-b-2 border-blue-400 rounded-full animate-spin"></div>
//                 </div>
//               ) : filteredNotifications?.length === 0 ? (
//                 <div className="flex flex-col items-center justify-center py-12 text-center">
//                   <Bell className="w-16 h-16 mb-4 text-gray-600" />
//                   <p className="text-gray-400">No notifications</p>
//                   <p className="mt-1 text-sm text-gray-500">
//                     {filter === 'all' 
//                       ? "You're all caught up!" 
//                       : filter === 'unread' 
//                       ? "No unread notifications" 
//                       : "No read notifications"}
//                   </p>
//                 </div>
//               ) : (
//                 <div className="divide-y divide-blue-800/30">
//                   {filteredNotifications.map((notification) => (
//                     <div
//                       key={notification._id}
//                       className={`p-4 hover:bg-blue-900/30 transition-all duration-300 cursor-pointer ${getNotificationBgColor(notification.type, notification.isRead)}`}
//                       onClick={() => {
//                         if (!notification.isRead) {
//                           handleMarkAsRead(notification._id);
//                         }
//                         if (notification.redirectUrl) {
//                           window.location.href = notification.redirectUrl;
//                         }
//                       }}
//                     >
//                       <div className="flex items-start gap-3">
//                         {/* Icon */}
//                         <div className="flex-shrink-0 mt-1">
//                           {getNotificationIcon(notification.type)}
//                         </div>

//                         {/* Content */}
//                         <div className="flex-1 min-w-0">
//                           <div className="flex items-start justify-between gap-2">
//                             <h3 className={`text-sm font-semibold ${
//                               notification.isRead ? 'text-gray-300' : 'text-white'
//                             }`}>
//                               {notification.title}
//                             </h3>
//                             <div className="flex items-center flex-shrink-0 gap-1">
//                               {!notification.isRead && (
//                                 <span className="w-2 h-2 bg-blue-500 rounded-full animate-pulse"></span>
//                               )}
//                             </div>
//                           </div>
                          
//                           <p className="mt-1 text-sm text-gray-400 line-clamp-2">
//                             {notification.message}
//                           </p>
                          
//                           <div className="flex items-center justify-between mt-2">
//                             <div className="flex items-center gap-1 text-xs text-gray-500">
//                               <Clock className="w-3 h-3" />
//                               <span>{formatTime(notification.createdAt)}</span>
//                             </div>
                            
//                             <div className="flex items-center gap-2">
//                               {!notification.isRead && (
//                                 <button
//                                   onClick={(e) => {
//                                     e.stopPropagation();
//                                     handleMarkAsRead(notification._id);
//                                   }}
//                                   className="p-1 text-blue-400 transition-colors hover:text-blue-300"
//                                   title="Mark as read"
//                                 >
//                                   <MailOpen className="w-4 h-4" />
//                                 </button>
//                               )}
//                               <button
//                                 onClick={(e) => {
//                                   e.stopPropagation();
//                                   setShowDeleteConfirm(notification._id);
//                                 }}
//                                 className="p-1 text-red-400 transition-colors hover:text-red-300"
//                                 title="Delete"
//                               >
//                                 <Trash2 className="w-4 h-4" />
//                               </button>
//                             </div>
//                           </div>
//                         </div>
//                       </div>
//                     </div>
//                   ))}
//                 </div>
//               )}
//             </div>
//           </div>
//         </div>
//       )}

//       {/* Delete Confirmation Modal */}
//       {showDeleteConfirm && (
//         <div className="fixed inset-0 z-50 flex items-center justify-center p-4">
//           <div className="absolute inset-0 bg-black/70 backdrop-blur-sm" onClick={() => setShowDeleteConfirm(null)} />
//           <div className="relative w-full max-w-md p-6 border border-blue-700 shadow-2xl bg-gradient-to-br from-gray-900 to-blue-900 rounded-xl animate-scale-in">
//             <div className="flex items-center gap-3 mb-4">
//               <div className="p-2 rounded-full bg-red-500/20">
//                 <AlertCircle className="w-6 h-6 text-red-400" />
//               </div>
//               <h3 className="text-xl font-bold text-white">Delete Notification</h3>
//             </div>
            
//             <p className="mb-6 text-gray-300">
//               Are you sure you want to delete this notification? This action cannot be undone.
//             </p>
            
//             <div className="flex gap-3">
//               <button
//                 onClick={() => setShowDeleteConfirm(null)}
//                 className="flex-1 px-4 py-2 text-white transition-colors bg-gray-700 rounded-lg hover:bg-gray-600"
//               >
//                 Cancel
//               </button>
//               <button
//                 onClick={() => handleDelete(showDeleteConfirm)}
//                 className="flex-1 px-4 py-2 text-white transition-colors bg-red-600 rounded-lg hover:bg-red-700"
//               >
//                 Delete
//               </button>
//             </div>
//           </div>
//         </div>
//       )}

//       {/* Add custom animations */}
//       <style jsx>{`
//         @keyframes slideIn {
//           from {
//             transform: translateX(100%);
//           }
//           to {
//             transform: translateX(0);
//           }
//         }
        
//         @keyframes scaleIn {
//           from {
//             opacity: 0;
//             transform: scale(0.9);
//           }
//           to {
//             opacity: 1;
//             transform: scale(1);
//           }
//         }
        
//         .animate-slide-in {
//           animation: slideIn 0.3s ease-out;
//         }
        
//         .animate-scale-in {
//           animation: scaleIn 0.2s ease-out;
//         }
        
//         .line-clamp-2 {
//           display: -webkit-box;
//           -webkit-line-clamp: 2;
//           -webkit-box-orient: vertical;
//           overflow: hidden;
//         }
//       `}</style>
//     </>
//   );
// };

// export default NotificationCenter;

import React, { useState, useEffect, useCallback } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { 
  Bell, 
  Trash2, 
  CheckCheck, 
  X, 
  Info, 
  AlertCircle, 
  AlertTriangle,
  CheckCircle,
  Clock,
  MailOpen
} from 'lucide-react';
import { 
  Get_Notification, 
  Delete_Notification, 
  Read_Notification, 
  ReadAll_Notification
} from '../../../services/oprations/Bussiness_Logic';
import toast from 'react-hot-toast';
import { useTheme } from '../../../Context/themeContext';

const NotificationCenter = ({ isOpen, onClose }) => {
  const { theme } = useTheme();
  const isDark = theme === 'dark';
  const dispatch = useDispatch();
  const { token } = useSelector((state) => state.auth);
  const { notification } = useSelector((state) => state.Notification);
  let notifications = notification;
  
  const [loading, setLoading] = useState(true);
  //const [unreadcount,setUnReadCount] = useState(0)
  const [filter, setFilter] = useState('all');
  const [showDeleteConfirm, setShowDeleteConfirm] = useState(null);

  // ─── Theme-aware classes ──────────────────────────────────────────────
  //const bgPrimary = isDark? 'bg-gradient-to-br from-gray-900 via-blue-900 to-gray-900': 'bg-gradient-to-br from-gray-50 via-blue-50 to-gray-50';
  
  const bgHeader = isDark ? 'bg-blue-900/30 border-blue-800/50' : 'bg-white/80 border-gray-200';
  const bgPanel = isDark ? 'bg-gradient-to-br from-gray-900 via-blue-900 to-gray-900' : 'bg-white';
  const bgFilter = isDark ? 'bg-blue-900/20 border-blue-800/50' : 'bg-gray-100 border-gray-200';
  const bgFilterActive = isDark ? 'bg-blue-600' : 'bg-blue-500';
  const bgFilterInactive = isDark ? 'bg-gray-800/50 text-gray-300 hover:bg-gray-700/50' : 'bg-gray-200/80 text-gray-600 hover:bg-gray-300/80';
  const bgActions = isDark ? 'border-blue-800/50' : 'border-gray-200';
  const bgItemHover = isDark ? 'hover:bg-blue-900/30' : 'hover:bg-gray-100';
  
  const bgUnread = (type) => {
    //const base = isDark ? 'bg-gray-800/30' : 'bg-gray-50';
    switch (type) {
      case 'SUCCESS':
        return isDark ? 'bg-green-900/20 border-l-4 border-green-500' : 'bg-green-50 border-l-4 border-green-500';
      case 'WARNING':
        return isDark ? 'bg-yellow-900/20 border-l-4 border-yellow-500' : 'bg-yellow-50 border-l-4 border-yellow-500';
      case 'ERROR':
        return isDark ? 'bg-red-900/20 border-l-4 border-red-500' : 'bg-red-50 border-l-4 border-red-500';
      default:
        return isDark ? 'bg-blue-900/20 border-l-4 border-blue-500' : 'bg-blue-50 border-l-4 border-blue-500';
    }
  };
  
  const bgRead = isDark ? 'bg-gray-800/30' : 'bg-gray-50';
  
  const borderColor = isDark ? 'border-blue-800/50' : 'border-gray-200';
  //const borderLight = isDark ? 'border-blue-800/30' : 'border-gray-100';
  const dividerColor = isDark ? 'divide-blue-800/30' : 'divide-gray-200';
  
  const textPrimary = isDark ? 'text-white' : 'text-gray-900';
  //const textSecondary = isDark ? 'text-gray-300' : 'text-gray-700';
  const textMuted = isDark ? 'text-gray-400' : 'text-gray-500';
  const textLight = isDark ? 'text-gray-500' : 'text-gray-400';
  const textUnread = isDark ? 'text-white' : 'text-gray-900';
  const textRead = isDark ? 'text-gray-300' : 'text-gray-600';
  
  const iconColor = isDark ? 'text-blue-400' : 'text-blue-600';
  const iconSuccess = isDark ? 'text-green-400' : 'text-green-600';
  const iconWarning = isDark ? 'text-yellow-400' : 'text-yellow-600';
  const iconError = isDark ? 'text-red-400' : 'text-red-600';
  const iconInfo = isDark ? 'text-blue-400' : 'text-blue-600';
  
  const shadowColor = isDark ? 'shadow-2xl' : 'shadow-xl';
  const shadowDelete = isDark ? 'shadow-2xl' : 'shadow-xl';

   // Get notification icon based on type
  const getNotificationIcon = (type) => {
    const iconClasses = "w-5 h-5";
    switch (type) {
      case 'SUCCESS':
        return <CheckCircle className={`${iconClasses} ${iconSuccess}`} />;
      case 'WARNING':
        return <AlertTriangle className={`${iconClasses} ${iconWarning}`} />;
      case 'ERROR':
        return <AlertCircle className={`${iconClasses} ${iconError}`} />;
      default:
        return <Info className={`${iconClasses} ${iconInfo}`} />;
    }
  };

  const fetchNotifications = useCallback(async () => {
    setLoading(true);
    await dispatch(Get_Notification(token));
    setLoading(false);
  },[dispatch, token]);
 // Fetch notifications when component mounts or when panel opens
  useEffect(() => {
    if (isOpen) {
      fetchNotifications();
    }
  }, [isOpen, fetchNotifications]);


  // Get notification background color based on type
  const getNotificationBgColor = (type, isRead) => {
    if (isRead) return bgRead;
    return bgUnread(type);
  };

  // Format time
  const formatTime = (date) => {
    const now = new Date();
    const notificationDate = new Date(date);
    const diffMs = now - notificationDate;
    const diffMins = Math.floor(diffMs / 60000);
    const diffHours = Math.floor(diffMs / 3600000);
    const diffDays = Math.floor(diffMs / 86400000);

    if (diffMins < 1) return 'Just now';
    if (diffMins < 60) return `${diffMins} min ago`;
    if (diffHours < 24) return `${diffHours} hour${diffHours > 1 ? 's' : ''} ago`;
    if (diffDays < 7) return `${diffDays} day${diffDays > 1 ? 's' : ''} ago`;
    return notificationDate.toLocaleDateString();
  };

  // Handle mark as read
  const handleMarkAsRead = async (id) => {
    await dispatch(Read_Notification(id, token));
    toast.success('Marked as read');
  };

  // Handle delete
  const handleDelete = async (id) => {
    await dispatch(Delete_Notification(id, token));
    setShowDeleteConfirm(null);
    toast.success('Notification deleted');
  };

  // Handle mark all as read
  const handleMarkAllAsRead = async () => {
    await dispatch(ReadAll_Notification(token));
    toast.success('All notifications marked as read');
  };

  // Filter notifications
  const filteredNotifications = notifications?.filter(notif => {
    if (filter === 'unread') return !notif.isRead;
    if (filter === 'read') return notif.isRead;
    return true;
  });

  const unreadCount = notifications?.filter(n => !n.isRead).length || 0;

  return (
    <>
      {/* Notification Sidebar Panel */}
      {isOpen && (
        <div className="fixed inset-0 z-50 overflow-hidden">
          {/* Backdrop */}
          <div 
            className={`absolute inset-0 transition-opacity duration-300 ${isDark ? 'bg-black/50' : 'bg-black/30'} backdrop-blur-sm`}
            onClick={onClose}
          />
          
          {/* Notification Panel - Slides in from right */}
          <div className={`absolute top-0 right-0 w-full h-full max-w-md border-l ${shadowColor} ${bgPanel} ${borderColor} animate-slide-in transition-colors duration-300`}>
            {/* Header */}
            <div className={`flex items-center justify-between p-4 border-b ${bgHeader} transition-colors duration-300`}>
              <div className="flex items-center gap-2">
                <Bell className={`w-6 h-6 ${iconColor}`} />
                <h2 className={`text-xl font-bold ${textPrimary}`}>Notifications</h2>
                {unreadCount > 0 && (
                  <span className={`px-2 py-1 text-xs text-red-400 rounded-full bg-red-500/20`}>
                    {unreadCount} unread
                  </span>
                )}
              </div>
              <button
                onClick={onClose}
                className={`p-1 transition-colors rounded-lg ${isDark ? 'hover:bg-blue-800/50' : 'hover:bg-gray-200'}`}
              >
                <X className={`w-5 h-5 ${isDark ? 'text-gray-400' : 'text-gray-600'}`} />
              </button>
            </div>

            {/* Filter Tabs */}
            <div className={`flex gap-2 p-4 border-b ${bgFilter} transition-colors duration-300`}>
              <button
                onClick={() => setFilter('all')}
                className={`flex-1 px-3 py-2 rounded-lg text-sm font-medium transition-all duration-300 ${
                  filter === 'all'
                    ? `${bgFilterActive} text-white shadow-lg`
                    : bgFilterInactive
                }`}
              >
                All
              </button>
              <button
                onClick={() => setFilter('unread')}
                className={`flex-1 px-3 py-2 rounded-lg text-sm font-medium transition-all duration-300 ${
                  filter === 'unread'
                    ? `${bgFilterActive} text-white shadow-lg`
                    : bgFilterInactive
                }`}
              >
                Unread
              </button>
              <button
                onClick={() => setFilter('read')}
                className={`flex-1 px-3 py-2 rounded-lg text-sm font-medium transition-all duration-300 ${
                  filter === 'read'
                    ? `${bgFilterActive} text-white shadow-lg`
                    : bgFilterInactive
                }`}
              >
                Read
              </button>
            </div>

            {/* Actions Bar */}
            {notifications?.length > 0 && (
              <div className={`flex items-center justify-between p-4 border-b ${bgActions} transition-colors duration-300`}>
                <button
                  onClick={handleMarkAllAsRead}
                  disabled={unreadCount === 0}
                  className={`flex items-center gap-2 px-3 py-1.5 text-sm ${isDark ? 'text-blue-100 hover:text-blue-50' : 'text-blue-700 hover:text-blue-900'} disabled:opacity-50 disabled:cursor-not-allowed transition-colors`}
                >
                  <CheckCheck className="w-4 h-4" />
                  Mark all as read
                </button>
                <span className={`text-xs ${textMuted}`}>
                  {notifications?.length} total
                </span>
              </div>
            )}

            {/* Notifications List */}
            <div className={`flex-1 overflow-y-auto h-[calc(100vh-180px)] ${isDark ? 'scrollbar-dark' : 'scrollbar-light'}`}>
              {loading ? (
                <div className="flex items-center justify-center py-12">
                  <div className={`w-8 h-8 border-b-2 ${isDark ? 'border-blue-400' : 'border-blue-600'} rounded-full animate-spin`}></div>
                </div>
              ) : filteredNotifications?.length === 0 ? (
                <div className="flex flex-col items-center justify-center py-12 text-center">
                  <Bell className={`w-16 h-16 ${isDark ? 'text-gray-600' : 'text-gray-300'}`} />
                  <p className={`${textMuted}`}>No notifications</p>
                  <p className={`mt-1 text-sm ${isDark ? 'text-gray-500' : 'text-gray-400'}`}>
                    {filter === 'all' 
                      ? "You're all caught up!" 
                      : filter === 'unread' 
                      ? "No unread notifications" 
                      : "No read notifications"}
                  </p>
                </div>
              ) : (
                <div className={`divide-y ${dividerColor}`}>
                  {filteredNotifications.map((notification) => (
                    <div
                      key={notification._id}
                      className={`p-4 ${bgItemHover} transition-all duration-300 cursor-pointer ${getNotificationBgColor(notification.type, notification.isRead)}`}
                      onClick={() => {
                        if (!notification.isRead) {
                          handleMarkAsRead(notification._id);
                        }
                        if (notification.redirectUrl) {
                          window.location.href = notification.redirectUrl;
                        }
                      }}
                    >
                      <div className="flex items-start gap-3">
                        {/* Icon */}
                        <div className="flex-shrink-0 mt-1">
                          {getNotificationIcon(notification.type)}
                        </div>

                        {/* Content */}
                        <div className="flex-1 min-w-0">
                          <div className="flex items-start justify-between gap-2">
                            <h3 className={`text-sm font-semibold ${
                              notification.isRead ? textRead : textUnread
                            }`}>
                              {notification.title}
                            </h3>
                            <div className="flex items-center flex-shrink-0 gap-1">
                              {!notification.isRead && (
                                <span className="w-2 h-2 bg-blue-500 rounded-full animate-pulse"></span>
                              )}
                            </div>
                          </div>
                          
                          <p className={`mt-1 text-sm ${textMuted} line-clamp-2`}>
                            {notification.message}
                          </p>
                          
                          <div className="flex items-center justify-between mt-2">
                            <div className={`flex items-center gap-1 text-xs ${textLight}`}>
                              <Clock className="w-3 h-3" />
                              <span>{formatTime(notification.createdAt)}</span>
                            </div>
                            
                            <div className="flex items-center gap-2">
                              {!notification.isRead && (
                                <button
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    handleMarkAsRead(notification._id);
                                  }}
                                  className={`p-1 ${isDark ? 'text-blue-400 hover:text-blue-300' : 'text-blue-600 hover:text-blue-800'} transition-colors`}
                                  title="Mark as read"
                                >
                                  <MailOpen className="w-4 h-4" />
                                </button>
                              )}
                              <button
                                onClick={(e) => {
                                  e.stopPropagation();
                                  setShowDeleteConfirm(notification._id);
                                }}
                                className={`p-1 ${isDark ? 'text-red-400 hover:text-red-300' : 'text-red-600 hover:text-red-800'} transition-colors`}
                                title="Delete"
                              >
                                <Trash2 className="w-4 h-4" />
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              )}
            </div>
          </div>
        </div>
      )}

      {/* Delete Confirmation Modal */}
      {showDeleteConfirm && (
        <div className="fixed inset-0 z-50 flex items-center justify-center p-4">
          <div className={`absolute inset-0 ${isDark ? 'bg-black/70' : 'bg-black/40'} backdrop-blur-sm`} onClick={() => setShowDeleteConfirm(null)} />
          <div className={`relative w-full max-w-md p-6 border ${borderColor} ${shadowDelete} ${isDark ? 'bg-gradient-to-br from-gray-900 to-blue-900' : 'bg-white'} rounded-xl animate-scale-in transition-colors duration-300`}>
            <div className="flex items-center gap-3 mb-4">
              <div className={`p-2 rounded-full ${isDark ? 'bg-red-500/20' : 'bg-red-100'}`}>
                <AlertCircle className={`w-6 h-6 ${isDark ? 'text-red-400' : 'text-red-600'}`} />
              </div>
              <h3 className={`text-xl font-bold ${textPrimary}`}>Delete Notification</h3>
            </div>
            
            <p className={`mb-6 ${isDark ? 'text-gray-300' : 'text-gray-600'}`}>
              Are you sure you want to delete this notification? This action cannot be undone.
            </p>
            
            <div className="flex gap-3">
              <button
                onClick={() => setShowDeleteConfirm(null)}
                className={`flex-1 px-4 py-2 ${isDark ? 'bg-gray-700 hover:bg-gray-600' : 'bg-gray-200 hover:bg-gray-300'} text-white rounded-lg transition-colors`}
              >
                Cancel
              </button>
              <button
                onClick={() => handleDelete(showDeleteConfirm)}
                className="flex-1 px-4 py-2 text-white transition-colors bg-red-600 rounded-lg hover:bg-red-700"
              >
                Delete
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Add custom animations */}
      <style jsx>{`
        @keyframes slideIn {
          from {
            transform: translateX(100%);
          }
          to {
            transform: translateX(0);
          }
        }
        
        @keyframes scaleIn {
          from {
            opacity: 0;
            transform: scale(0.9);
          }
          to {
            opacity: 1;
            transform: scale(1);
          }
        }
        
        .animate-slide-in {
          animation: slideIn 0.3s ease-out;
        }
        
        .animate-scale-in {
          animation: scaleIn 0.2s ease-out;
        }
        
        .line-clamp-2 {
          display: -webkit-box;
          -webkit-line-clamp: 2;
          -webkit-box-orient: vertical;
          overflow: hidden;
        }
        
        /* Scrollbar styles */
        .scrollbar-dark::-webkit-scrollbar {
          width: 4px;
        }
        .scrollbar-dark::-webkit-scrollbar-track {
          background: rgba(30, 58, 138, 0.3);
          border-radius: 10px;
        }
        .scrollbar-dark::-webkit-scrollbar-thumb {
          background: rgba(59, 130, 246, 0.5);
          border-radius: 10px;
        }
        .scrollbar-dark::-webkit-scrollbar-thumb:hover {
          background: rgba(59, 130, 246, 0.8);
        }
        
        .scrollbar-light::-webkit-scrollbar {
          width: 4px;
        }
        .scrollbar-light::-webkit-scrollbar-track {
          background: rgba(0, 0, 0, 0.05);
          border-radius: 10px;
        }
        .scrollbar-light::-webkit-scrollbar-thumb {
          background: rgba(0, 0, 0, 0.15);
          border-radius: 10px;
        }
        .scrollbar-light::-webkit-scrollbar-thumb:hover {
          background: rgba(0, 0, 0, 0.25);
        }
      `}</style>
    </>
  );
};

export default NotificationCenter;
